import { data } from '../../svg/Epilot/data';
import { makeIcon } from '../makeIcon';

export const Epilot = makeIcon(data, 'epilot', 'Epilot');

export default Epilot;
